import { SVGProps } from 'react';

export default function Location4(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3345)">
        <path
          d="M16.4818 2.685C14.7502 0.953333 12.4477 0 10.0002 0C7.55266 0 5.25016 0.954167 3.5185 2.685C1.78683 4.41583 0.833496 6.7175 0.833496 9.16667C0.833496 11.6158 1.78683 13.9167 3.54183 15.6708L6.82766 18.7067C7.67933 19.5408 8.80683 20 10.0002 20C11.1935 20 12.3202 19.5408 13.1552 18.7225L16.4818 15.6483C18.2135 13.9167 19.1668 11.615 19.1668 9.16667C19.1668 6.71833 18.2135 4.41583 16.4818 2.685ZM14.7493 7.26L9.92183 12.0158C9.6088 12.3263 9.18557 12.5001 8.74472 12.4993C8.30387 12.4985 7.88126 12.3232 7.56933 12.0117L5.251 9.765C5.09231 9.61106 5.00127 9.40039 4.99791 9.17934C4.99455 8.95828 5.07914 8.74494 5.23308 8.58625C5.38702 8.42756 5.59769 8.33652 5.81874 8.33316C6.0398 8.3298 6.25314 8.4144 6.41183 8.56833L8.73933 10.8242L13.5802 6.07333C13.7376 5.91818 13.9503 5.83194 14.1714 5.83358C14.3924 5.83522 14.6038 5.92461 14.7589 6.08208C14.9141 6.23956 15.0003 6.45221 14.9987 6.67327C14.997 6.89433 14.9076 7.10568 14.7502 7.26083L14.7493 7.26Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3345">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
